import range from "lodash/range";

const DEFAULT_SPEED = 200;
export const RATIO = 180; // = words / rate

export const MAX_SPEED = 360;
export const MIN_SPEED = 90;

export const STEP = (MAX_SPEED - MIN_SPEED) / 9;
export const DEFAULT_RATE = DEFAULT_SPEED / RATIO;
export const VALUES = [...range(MIN_SPEED, MAX_SPEED, STEP), MAX_SPEED];
